<script lang="ts" setup>
import { IYearMonth } from '@/coreDomainsModule/date';
import { ForecastForReceiptHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import TableCell from '../TableCell.vue';
import { computed } from 'vue';
import { COLUMN_NAME_FORECAST_DIFF, DiffAmountType, ForecastDiffColumnTypes } from './domains/entities/forecastDiffLastMonth';
import { ForecastDiffLastMonthTableContentViewModel } from './forecastDiffLastMonthTableContentViewModel';
import { ForecastDiffLastMonthService } from './domains/services/forecastDIffLastMonthService';

// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerKey: ForecastForReceiptHeaderKey;
    item: TableContentItem;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    isBold: boolean;
    forecastStartYearMonth?: IYearMonth;
    isChecked: boolean;
    isCheckedBusinessId: boolean;
  }>(),
  {
    forecastStartYearMonth: undefined,
  }
);

// emits
const emits = defineEmits<{
  (e: 'onClickNarrow'): void;
}>();

const forecastDiffLastMonthTableCellVM = new ForecastDiffLastMonthTableContentViewModel();

const textAlign = computed(() => {
  if (props.header.key === 'SupplierForecastCreateStatus') {
    return 'center';
  }
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

const columnType = computed(() => {
  return ForecastDiffLastMonthService.getColumnType(props.header.key);
});

/**
 * セルのクラスを返す
 * @param columnType - 列の種類
 * @param diffAmountStatus - 差分の種類
 */
const cellItemClasses = (columnType: ForecastDiffColumnTypes, diffAmountStatus: DiffAmountType) => {
  return [
    props.isBold ? 'table-cell-content--bold' : '',
    columnType === 'diffAmount' ? 'table-cell-content__diff-amount' + ` table-cell-content__diff-amount--${diffAmountStatus}` : '',
  ];
};
</script>

<template>
  <TableCell
    :class="[forecastDiffLastMonthTableCellVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: forecastDiffLastMonthTableCellVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    class="table-cell base-table__body--fixed"
    :text-align="textAlign"
    :table-content-property="header"
    :tool-tip-value="forecastDiffLastMonthTableCellVM.getDisplayForecastDiffItem(headerKey, columnType, item, forecastStartYearMonth)"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <span
      class="table-cell-content"
      :class="cellItemClasses(columnType, forecastDiffLastMonthTableCellVM.getDiffAmountStatus(headerKey, item, forecastStartYearMonth))"
      @click="emits('onClickNarrow')"
    >
      {{ forecastDiffLastMonthTableCellVM.getDisplayForecastDiffItem(headerKey, columnType, item, forecastStartYearMonth) }}
    </span>
  </TableCell>
</template>

<style scoped lang="scss">
.table-cell-content {
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &__diff-amount {
    color: $textDefault;

    &--up {
      color: $semanticPrimary;
    }
    &--down {
      color: $optionalPink;
    }
  }

  &--bold {
    font-weight: bold;
  }
}
</style>
